import React from 'react';

export const MapIcon = (props) => {
  const {color} = props;
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M21.447 6.105L15.447 3.105C15.166 2.964 14.834 2.964 14.552 3.105L9 5.882L3.447 3.105C3.137 2.951 2.768 2.966 2.474 3.149C2.18 3.332 2 3.653 2 4V17C2 17.379 2.214 17.725 2.553 17.895L8.553 20.895C8.834 21.036 9.166 21.036 9.448 20.895L15 18.118L20.553 20.894C20.694 20.965 20.847 21 21 21C21.183 21 21.365 20.95 21.525 20.851C21.82 20.668 22 20.347 22 20V7C22 6.621 21.786 6.275 21.447 6.105ZM10 7.618L14 5.618V16.382L10 18.382V7.618ZM4 5.618L8 7.618V18.382L4 16.382V5.618ZM20 18.382L16 16.382V5.618L20 7.618V18.382Z" fill={color ? color :"#616E86"}/>
    </svg>
  )
}